<form [formGroup]="formGroup">

  <span class="small-title"> {{'offer.createOffer.coverageSection.title'|translate}}</span>
  <div class="field-container coverage-width">
    <app-input-field [control]="formGroup.controls.amountCovered"
                     [label]="'offer.createOffer.coverageSection.coverage'|translate">
      <div class="input-container">
        <input
          formControlName="amountCovered"
          appNumberFormat
          [maxNumber]="maxCoverage"
          class="input amountCovered">
        <span class="percentage-symbol">%</span>
      </div>
    </app-input-field>
  </div>


  <div class="field-container" *ngIf="showLeading">
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      name="leading"
      formControlName="isLeading">
      <span class="small-text">
        {{'offer.createOffer.coverageSection.role'|translate}}{{"*"}}
      </span>
      <mat-radio-button class="example-radio-button coverageSectionRole" color="primary" [disabled]="hasLeading$ |async" [value]="true">
        {{'offer.createOffer.coverageSection.leading'|translate}}
      </mat-radio-button>
      <mat-radio-button  [disabled]="!(needsFollowing$ |async)"
        class="example-radio-button coverageSectionRole" color="primary" [value]="false">
        {{'offer.createOffer.coverageSection.participating'|translate}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</form>
